export default {
    activity: 'Loading Data...',
    addToMyAnalogModalDesc: 'Add product to the Products section of myAnalog (to receive notifications), to an existing project or to a new project.',
    addToMyAnalogModalDescTable: 'Add models to the Parametric Searches of myAnalog, to an existing project or to a new project.',
    addToMyAnalogDropdownTitle: 'Add product to',
    addToMyAnalogDropdownTitleTable: 'Add all models to',
    myAnalogProjectProduct: 'Products on myAnalog',
    myAnalogProjectTable: 'Parametric searches on myAnalog',
    myAnalogNewProject: 'New Project',
    createNewProject: 'Create New Project',
    projectName: 'Project Name',
    projectNameTakenError: 'The Project Name is already taken. Try giving a different name',
    receivePcnPdnNotifications: 'Receive PCN/PDN notifications for all part models.',
    projectDescription: 'Description',
    tableName: 'Table Name',
    note: 'Note',
    opensModal : 'Opens a dialog box.',
    button: {
        and: 'AND',
        blanks: 'Blanks',
        cancel: 'Cancel',
        confirm: 'Confirm',
        compare: 'Compare',
        default: 'Default',
        deselectAll: 'Deselect All',
        downloadToExcel: 'Download to Excel',
        feedBack: 'Send Feedback',
        filters: {
            minimize: 'Minimize Filters',
            maximize: 'Maximize Filters',
            hide: 'Hide Filters',
            show: 'Show Filters',
            reset: 'Reset'
        },
        hide: 'HIDE',
        last: 'Last',
        next: 'Next',
        ok: 'OK',
        or: 'OR',
        parameters: {
            choose: 'Manage Columns',
            all: 'All'
        },
        previous: 'Previous',
        quickTips: 'Quick Tips',
        reset: 'Reset Table',
        save: 'Save to myAnalog',
        selectAll: 'Select All',
        share: 'Share',
        showAll: 'Show All',
        sortByNewest: 'Sort by Newest',
        toggleDescription: 'Toggle Description Column',
        toggleHardware: 'Toggle Hardware Column',
        toggleStatus: 'Toggle Status Column',
        toggleTools: 'Toggle Tools Column',
        copyLink: 'Copy Link',
        copied: 'Copied',
        viewParts: 'View {count} Parts',
        addedToMyAnalog: 'Added to myAnalog',
        addToMyAnalog: 'Add to myAnalog',
        addToMyCart: 'Add to My Cart',
        viewDataSheet: 'View Data Sheet',
        dragAndDrop: 'Drag And Drop',
        hideColumn: 'Hide',
        sort: 'Sort',
        sortAsc: 'Sort Ascending',
        sortDesc: 'Sort Descending'
    },
    excel: {
        columnName: 'Column Name',
        cover: 'Cover',
        dateCreated: 'Date Created',
        display: {
            raw: 'Raw Data Display',
            web: 'Web Display'
        },
        filename: 'ADIParametricSearch',
        filter: {
            conditions: 'Filter Conditions',
            values: 'Filter Values',
            none: 'None'
        },
        productType: 'Product Type',
        webLink: 'Web Link'
    },
    footnote: {
        pricing: {
            disclosure: '* The pricing listed here is provided only for budgetary purposes as recommended list price in U.S. Dollars in the United States ex factor per unit for the stated volume.',
            evaluationBoardsAndKits: 'Pricing displayed for Evaluation Boards and Kits is based on 1-piece pricing.',
            unavailable: '** Pricing is currently unavailable. Click on the product number to see the Product Page for additional information.'
        }
    },
    filterParts: 'Filter Parts',
    checkDistributorInventory: 'Check Distributor Inventory',
    inputs: {
        defaultPlaceholder: 'Filter {name}'
    },
    link: {
        downloadDataSheet: 'Download Data Sheet',
        viewDataSheet: 'View Data Sheet',
        sampleAndBuy: 'Sample &amp; Buy',
        viewDocumentation: 'View Documentation'
    },
    new: 'NEW',
    noResults: 'The search yielded no results',
    pageReq: 'You cannot enter a value greater or less than the number of available pages.',
    partNumber: 'Part Number',
    parts: 'parts',
    tooltip: {
        referenceCircuit: 'Reference Circuit',
        evaluationBoard: 'Evaluation Board'
    },
    totalPages: 'of {total}',
    valuesSelected: 'Values Selected',
    selectOneOrMore: 'Select one or more options',
    recommendedNewDesigns: 'Recommended for new designs',
    items: 'items',
    resultPerPage: 'Result Per Page',
    page: 'Page',
    of: 'of'
};